import * as Oidc from 'oidc-client-ts';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from '@module/shared/routerCompat';
import { IAuthenticationProps, IConnectedComponent } from '../../../reducers';
import { AuthorizedUserService } from '../services/authorizedUserService';

import { Settings } from '../Settings';

export class RequireAuthenticationComponent extends React.Component<IConnectedComponent & IAuthenticationProps, any> {
  constructor(props: any) {
    super(props);

    this.state = { userManager: new Oidc.UserManager(Settings), loading: true };

    this.onUserLoaded = this.onUserLoaded.bind(this);
    this.onSilentRenewError = this.onSilentRenewError.bind(this);
    this.onAccessTokenExpired = this.onAccessTokenExpired.bind(this);
    this.onAccessTokenExpiring = this.onAccessTokenExpiring.bind(this);
    this.onUserUnloaded = this.onUserUnloaded.bind(this);
    this.onUserSignedOut = this.onUserSignedOut.bind(this);
  }
  componentWillUnmount() {
    this.state.userManager.events.removeUserLoaded(this.onUserLoaded);
    this.state.userManager.events.removeSilentRenewError(this.onSilentRenewError);
    this.state.userManager.events.removeAccessTokenExpired(this.onAccessTokenExpired);
    this.state.userManager.events.removeAccessTokenExpiring(this.onAccessTokenExpiring);
    this.state.userManager.events.removeUserUnloaded(this.onUserUnloaded);
    this.state.userManager.events.removeUserSignedOut(this.onUserSignedOut);
  }

  async componentDidMount() {
    this.state.userManager.events.addUserLoaded(this.onUserLoaded);
    this.state.userManager.events.addSilentRenewError(this.onSilentRenewError);
    this.state.userManager.events.addAccessTokenExpired(this.onAccessTokenExpired);
    this.state.userManager.events.addAccessTokenExpiring(this.onAccessTokenExpiring);
    this.state.userManager.events.addUserUnloaded(this.onUserUnloaded);
    this.state.userManager.events.addUserSignedOut(this.onUserSignedOut);
    if (!this.props.loggedInUser) {
      const user: Oidc.User = await this.state.userManager.getUser();
      this.props.login(user);
    }
    this.setState({ loading: false });
  }
  // event callback when the user has been loaded (on silent renew or redirect)
  onUserLoaded(user: any) {
    this.props.login(user);
  }

  // event callback when silent renew errored
  // tslint:disable:no-empty
  onSilentRenewError(error: any) {
  }

  // event callback when the access token expired
  onAccessTokenExpired() {
    this.props.tokenExpired();
  }

  // event callback when the user is logged out
  onUserUnloaded() {
  }

  // event callback when the user is expiring
  onAccessTokenExpiring() {
  }

  // event callback when the user is signed out
  onUserSignedOut() {
  }
  // tslint:enable:no-empty

  render() {
    const { children, loggedInUser } = this.props;

    if (this.state.loading) {
      return null;
    }

    if (loggedInUser) {
      return children;
    }

    return <Redirect to='/login' />;
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequireAuthenticationComponent));

function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser,
  };
}

function mapDispatchToProps(dispatch: any, ownProps: any) {
  return {
    async login(user: any) {
      if (user && !user.expired) {
        const userPermissions = await AuthorizedUserService.getUserByEmail(user.profile.email, user);
        dispatch({ type: 'USER_LOGIN', loggedInUser: user, userPermissions });
      }
    },
    tokenExpired() {
      dispatch({ type: 'USER_LOGIN', loggedInUser: null });
    },
  };
}
